<template>
  <div class="h-100 d-flex flex-column bg-light">
    <div class="p-2 border-bottom bg-white d-flex align-items-center justify-content-between shadow-sm flex-wrap" style="z-index: 10;">
      <div class="d-flex align-items-center flex-wrap">
        <span class="font-weight-bold mr-2 text-dark" style="font-size: 1.1rem; white-space: nowrap;">异动提醒</span>
        <span class="text-muted mr-2 small">连续10个交易日内涨幅偏离值累计达到100% | 连续30个交易日内涨幅偏离值累计达到200% 红色:已经达到异动 黄色:即将到达</span>
        
        
      </div>
      <div class="d-flex align-items-center">
        <WxShare title="异动提醒 - 自在量化" desc="连续10个/30个交易日内涨幅偏离值累计达到100%/200%的股票异动监控" class="mr-2" />
        <b-button variant="outline-primary" size="sm" @click="fetchList" class="border-0 mr-1">
          <b-icon icon="arrow-clockwise"></b-icon>
        </b-button>
        <b-button variant="outline-primary" size="sm" @click="downloadScreenshot" class="border-0">
          <b-icon icon="download"></b-icon>
        </b-button>
      </div>
    </div>
    <div class="flex-grow-1 bg-white overflow-auto" ref="tableContainer">
      <div v-if="loading" class="text-center p-5">
        <b-spinner small variant="secondary"></b-spinner>
      </div>
      <div v-else-if="items.length===0" class="text-center p-5 text-muted">暂无数据</div>
      <div v-else>
        <div v-if="!isMobile" class="px-3 pt-2">
         <div style="max-width: 1150px;" class="mx-auto w-100">
           <b-table
             :items="mergedItems"
             :fields="fields"
             striped
             hover
             small
             head-variant="light"
             class="mb-0 border shadow-sm rounded sticky-header-table"
             style="font-size: 12px;"
           >
          <template #cell(symbol)="data">
            <div class="font-weight-bold" style="white-space: nowrap; cursor: pointer;" @click="openSidebar(data.item)">
              <div :class="data.item.is_monitored ? 'text-danger' : 'text-dark'">{{ data.item.symbol_name || '' }}</div>
              <div class="small text-secondary font-weight-normal">{{ data.item.symbol_code }}</div>
              <div v-if="data.item.is_monitored" class="small text-danger mt-1" style="font-size: 12px;">
                 {{ data.item.monitor_start_date }}~{{ data.item.monitor_end_date }}
              </div>
            </div>
          </template>

          <template #cell(gain)="data">
            <div class="mb-1">{{ formatPct(data.item.gain100) }}</div>
            <div>{{ formatPct(data.item.gain200) }}</div>
          </template>

          <template #cell(days)="data">
            <div class="mb-1">{{ data.item.days1 }}</div>
            <div>{{ data.item.days2 }}</div>
          </template>

          <template #cell(trigger_today)="data">
            <div :class="getTodayStyle(data.item.gain_to_100, data.item.px_change_rate)" class="mb-1 rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100) }}</span>
            </div>
            <div :class="getTodayStyle(data.item.gain_to_200, data.item.px_change_rate)" class="rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200) }}</span>
            </div>
          </template>

          <template #cell(trigger_tomorrow)="data">
            <div :class="getFutureStyle(data.item.gain_to_100_2)" class="mb-1 rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100_2) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100_2) }}</span>
            </div>
            <div :class="getFutureStyle(data.item.gain_to_200_2)" class="rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200_2) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200_2) }}</span>
            </div>
          </template>

          <template #cell(trigger_day_after)="data">
            <div :class="getFutureStyle(data.item.gain_to_100_3)" class="mb-1 rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100_3) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100_3) }}</span>
            </div>
            <div :class="getFutureStyle(data.item.gain_to_200_3)" class="rounded px-1">
               <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200_3) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200_3) }}</span>
            </div>
          </template>

          <template #cell(px_change_rate)="data">
            <div class="font-weight-bold" :class="getColorClass(data.item.px_change_rate)">
              {{ formatPct(data.item.px_change_rate) }}
            </div>
            <div :class="getColorClass(data.item.px_change_rate)">
              {{ formatPrice(data.item.last_px) }}
            </div>
          </template>
        </b-table>
        </div>
        </div>
        <div v-else class="p-1 bg-light" style="min-height: 100%;">
          <div v-for="(item, idx) in mergedItems" :key="idx" class="card border-0 shadow-sm mb-1">
             <div class="card-body p-2">
                <div class="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom">
                   <div @click="openSidebar(item)">
                     <span class="font-weight-bold mr-2" :class="item.is_monitored ? 'text-danger' : ''" style="font-size: 1rem;">{{ item.symbol_name }}</span>
                     <span class="text-secondary small">{{ item.symbol_code }}</span>
                     <div v-if="item.is_monitored" class="small text-danger mt-1">
                        {{ item.monitor_start_date }}~{{ item.monitor_end_date }}
                     </div>
                   </div>
                   <div class="text-right">
                     <span class="font-weight-bold mr-2" :class="getColorClass(item.px_change_rate)">{{ formatPrice(item.last_px) }}</span>
                     <span class="small" :class="getColorClass(item.px_change_rate)">{{ formatPct(item.px_change_rate) }}</span>
                   </div>
                </div>

                <div v-if="item.days1" class="bg-light p-1 rounded mb-1">
                   <div class="d-flex justify-content-between align-items-center small mb-1 px-1">
                      <div>
                        <span class="badge badge-primary scale-8 mr-1">异动1</span>
                        <span class="text-secondary">{{ item.days1 }}天</span>
                      </div>
                      <div style="font-size: 0.85rem;">
                        <span class="text-muted mr-1">累计</span>{{ formatPct(item.gain100) }}
                      </div>
                   </div>
                   <div class="d-flex justify-content-between align-items-center bg-white p-1 rounded" style="font-size: 0.85rem;">
                      <div class="text-center" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">今日</div>
                        <div :class="getMobileThresholdClass(item.gain_to_100, item.px_change_rate)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_100) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">明日</div>
                        <div :class="getMobileFutureClass(item.gain_to_100_2)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100_2) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_100_2) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">后日</div>
                        <div :class="getMobileFutureClass(item.gain_to_100_3)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100_3) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_100_3) }}</span>
                        </div>
                      </div>
                   </div>
                </div>

                <div v-if="item.days2" class="bg-light p-1 rounded">
                   <div class="d-flex justify-content-between align-items-center small mb-1 px-1">
                      <div>
                        <span class="badge badge-warning scale-8 mr-1">异动2</span>
                        <span class="text-secondary">{{ item.days2 }}天</span>
                      </div>
                      <div style="font-size: 0.85rem;">
                        <span class="text-muted mr-1">累计</span>{{ formatPct(item.gain200) }}
                      </div>
                   </div>
                   <div class="d-flex justify-content-between align-items-center bg-white p-1 rounded" style="font-size: 0.85rem;">
                      <div class="text-center" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">今日</div>
                        <div :class="getMobileThresholdClass(item.gain_to_200, item.px_change_rate)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_200) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">明日</div>
                        <div :class="getMobileFutureClass(item.gain_to_200_2)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200_2) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_200_2) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">后日</div>
                        <div :class="getMobileFutureClass(item.gain_to_200_3)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200_3) }}</span> / <span class="small font-weight-normal">{{ formatPrice(item.price_to_200_3) }}</span>
                        </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </div>
    <StockInfoSidebar :symbol_code="sidebarSymbolCode" :symbol_name="sidebarSymbolName" :date_mark="date1"></StockInfoSidebar>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'
import WxShare from '@/components/share/WxShare.vue'
import html2canvas from 'html2canvas'

export default {
  components: {
    StockInfoSidebar,
    WxShare
  },
  data(){
    return {
      sidebarSymbolCode: '',
      sidebarSymbolName: '',
      isGeneratingScreenshot: false,
      date1: new Date().toISOString().slice(0, 10),
      loading: false,
      items: [],
      windowWidth: window.innerWidth,
      fields: [
        { key: 'symbol', label: '股票', sortable: false, thStyle: { width: '10%' } },
        { key: 'gain', label: '累计涨幅', sortable: false, class: 'text-right', thClass: 'text-right', thStyle: { width: '8%' } },
        { key: 'days', label: '天数', sortable: false, class: 'text-right', thClass: 'text-right', thStyle: { width: '5%' } },
        { 
          key: 'trigger_today', 
          label: '今日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { 
          key: 'trigger_tomorrow', 
          label: '明日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { 
          key: 'trigger_day_after', 
          label: '后日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { key: 'px_change_rate', label: '实时(幅/价)', sortable: true, class: 'text-right', thClass: 'text-right', thStyle: { width: '10%' } }
      ]
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768
    },
    mergedItems() {
      return this.items.map(item => {
        // Check validity based on threshold price (0 means no data)
        const hasT1 = item.t1_threshold_price > 0;
        const hasT2 = item.t2_threshold_price > 0;
        
        return {
          ...item,
          // Map backend t1_ fields to frontend fields, return null if invalid
          gain100: hasT1 ? item.t1_gain_pct : null,
          days1: hasT1 ? item.t1_days : null,
          dist100: hasT1 ? item.t1_space_pct : null,
          gain_to_100: hasT1 ? item.t1_threshold_gain_pct : null,
          price_to_100: hasT1 ? item.t1_threshold_price : null,
          gain_to_100_2: hasT1 ? item.t1_threshold_gain_pct2 : null,
          price_to_100_2: hasT1 ? item.t1_threshold_price2 : null,
          gain_to_100_3: hasT1 ? item.t1_threshold_gain_pct3 : null,
          price_to_100_3: hasT1 ? item.t1_threshold_price3 : null,
          
          gain200: hasT2 ? item.t2_gain_pct : null,
          days2: hasT2 ? item.t2_days : null,
          dist200: hasT2 ? item.t2_space_pct : null,
          gain_to_200: hasT2 ? item.t2_threshold_gain_pct : null,
          price_to_200: hasT2 ? item.t2_threshold_price : null,
          gain_to_200_2: hasT2 ? item.t2_threshold_gain_pct2 : null,
          price_to_200_2: hasT2 ? item.t2_threshold_price2 : null,
          gain_to_200_3: hasT2 ? item.t2_threshold_gain_pct3 : null,
          price_to_200_3: hasT2 ? item.t2_threshold_price3 : null,
          
          // Ensure real-time fields are present (backend sends them merged)
          last_px: item.last_px,
          px_change_rate: item.px_change_rate
        }
      }).sort((a, b) => {
        // Sort by (min(gain_to_100, gain_to_200) - px_change_rate) ascending
        const getSortVal = (item) => {
           let v1 = item.gain_to_100;
           let v2 = item.gain_to_200;
           
           // Ensure numbers and handle null/undefined
           v1 = (v1 !== null && v1 !== undefined && v1 !== '') ? Number(v1) : Infinity;
           v2 = (v2 !== null && v2 !== undefined && v2 !== '') ? Number(v2) : Infinity;
           
           if (isNaN(v1)) v1 = Infinity;
           if (isNaN(v2)) v2 = Infinity;

           const minVal = Math.min(v1, v2);
           
           if (minVal === Infinity) return Infinity;
           
           let pxChange = item.px_change_rate;
           pxChange = (pxChange !== null && pxChange !== undefined && pxChange !== '') ? Number(pxChange) : 0;
           if (isNaN(pxChange)) pxChange = 0;
           
           return minVal - pxChange;
        }
        
        const valA = getSortVal(a);
        const valB = getSortVal(b);
        
        if (valA === Infinity && valB === Infinity) return 0;
        if (valA === Infinity) return 1;
        if (valB === Infinity) return -1;

        return valA - valB;
      })
    }
  },
  mounted(){
    this.setDefaultTradeDateByRule()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods:{
    onResize() {
      this.windowWidth = window.innerWidth
    },
    openSidebar(item) {
      this.sidebarSymbolCode = item.symbol_code
      this.sidebarSymbolName = item.symbol_name
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-stock')
    },
    setDefaultTradeDateByRule() {
      const now = new Date()
      // const today = new Date(now.getTime())
      const tomorrow = new Date(now.getTime() + 24 * 3600 * 1000)
      
      const referenceDate = tomorrow
      const dayEnd = referenceDate.toISOString().slice(0, 10)
      
      request_zzquant({
        url: '/market/trade/days',
        params: { days: 2, day_end: dayEnd }
      }).then(res => {
        if (res.data && res.data.code === 20000 && Array.isArray(res.data.data) && res.data.data.length > 0) {
          this.date1 = res.data.data[0] //永远取前一个交易日
        } else {
          this.date1 = referenceDate.toISOString().slice(0, 10)
        }
        this.fetchList()
      }).catch(() => {
        this.date1 = referenceDate.toISOString().slice(0, 10)
        this.fetchList()
      })
    },
    fetchList(){
      this.loading = true
      request_zzquant({
        url: '/market/movement/alerts',
        params: { date1: this.date1, type: 0, limit: 200, is_real: 1 }
      }).then(res=>{
        this.loading = false
        if (res.data.code === 20000) {
          this.items = res.data.data || []
        }
      }).catch(()=>{
        this.loading = false
      })
    },
    formatPrice(v){
      if (v===null || v===undefined) return '--'
      return Number(v).toFixed(2)
    },
    formatPct(v){
      if (v===null || v===undefined) return '--'
      return Number(v).toFixed(2) + '%'
    },
    getColorClass(val){
      if (val > 0) return 'text-danger'
      if (val < 0) return 'text-success'
      return ''
    },
    getTodayStyle(threshold, real) {
       if (threshold === null || real === null || real === undefined) return ''
       const diff = threshold - real
       if (threshold < real) return 'bg-danger text-white'
       if (diff > 0 && diff < 10) return 'bg-warning text-dark'
       return ''
    },
    getFutureStyle(dist) {
       if (dist === null || dist === undefined) return ''
       if (dist < 0) return 'bg-danger text-white'
       if (dist < 10) return 'bg-warning text-dark'
       return ''
    },
    getMobileFutureClass(val) {
       if (val === null || val === undefined) return ''
       if (val < 0) return 'text-danger font-weight-bold'
       if (val < 10) return 'text-warning font-weight-bold'
       return ''
    },
    getMobileThresholdClass(threshold, real) {
       if (threshold === null || real === null || real === undefined) return ''
       const diff = threshold - real
       if (threshold < real) return 'text-danger font-weight-bold'
       if (diff > 0 && diff < 10) return 'text-warning font-weight-bold'
       return ''
    },
    async downloadScreenshot() {
      if (this.isGeneratingScreenshot) return
      this.isGeneratingScreenshot = true
      
      try {
        const element = this.$refs.tableContainer
        if (!element) return

        // Create watermark div
        const watermark = document.createElement('div')
        watermark.innerHTML = '自在量化<br>quant.zizizaizai.com'
        watermark.style.position = 'fixed'
        watermark.style.top = '50%'
        watermark.style.left = '50%'
        watermark.style.transform = 'translate(-50%, -50%) rotate(-30deg)'
        watermark.style.fontSize = '40px'
        watermark.style.color = 'rgba(150, 150, 150, 0.4)'
        watermark.style.zIndex = '9999'
        watermark.style.pointerEvents = 'none'
        watermark.style.textAlign = 'center'
        watermark.style.fontWeight = 'bold'
        element.appendChild(watermark)

        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2, // Higher resolution
          backgroundColor: '#ffffff'
        })
        
        // Remove watermark
        element.removeChild(watermark)
        
        // Download
        const link = document.createElement('a')
        link.download = `异动提醒_${this.date1}.png`
        link.href = canvas.toDataURL('image/png')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
      } catch (error) {
        console.error('Screenshot failed:', error)
        this.$bvToast.toast('生成截图失败，请重试', {
          title: '错误',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isGeneratingScreenshot = false
      }
    }
  }
}
</script>

<style>
.sticky-header-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 1000;
  background-color: #f8f9fa !important;
  box-shadow: 0 1px 0 #dee2e6;
  border-top: none !important;
}
</style>
